import React, { useEffect, useState, useCallback, useRef } from "react";
import { View } from "react-native";
import { CreateResponsiveStyle, DEVICE_SIZES } from "rn-responsive-styles";
import { AppColors } from "../../../../utility/AppColors";
import { toast } from "react-toastify";
import { ShowLoader } from "../../../../common/ShowLoader";
import ChatHeader from "../../../../Components/chat-common-components/ChatHeader";
import ChatList from "../../../../Components/chat-common-components/ChatList";
import ChatMessageInput from "../../../../Components/chat-common-components/ChatMessageInput";
import NoChatFound from "../../../../Components/chat-common-components/NoChatFound";
import withErrorBoundary from "../../../../utility/auth/withErrorBoundary";
import { fetchChatHistoryID } from "../../../../services/chatAPI";
import { useChat } from "../../../../context/ChatContext";
import Separator from "../../../../Components/Separator";

const ChattingView = () => {
  const styles = useStyles();
  const { currentChat, userData, chatData, setChatData } = useChat();
  const chatID = currentChat?.conversationId;
  const [showLoader, setShowLoader] = useState(false);
  const [newMessage, setNewMessage] = useState("");

  const [selectionMode, setSelectionMode] = useState(false);
  const [selectedMessages, setSelectedMessages] = useState([]);

  useEffect(() => {
    if (chatID && userData) {
      fetchChatHistory();
    }

    return () => {
      handleCancelSelection();
    };
  }, [chatID]);

  const fetchChatHistory = async () => {
    if (!chatID || !userData?.accessToken) return;
    setShowLoader(true);
    try {
      const response = await fetchChatHistoryID(userData.accessToken, chatID);
      setShowLoader(false);
      if (response.statusCode === 200) {
        const sortedMessages = response.body.messages.sort(
          (a, b) => b.timestamp - a.timestamp
        );
        setChatData(sortedMessages || []);
      } else {
        toast.error("Error fetching chat history");
      }
    } catch (error) {
      setShowLoader(false);
      toast.error("Error fetching chat history");
    }
  };
  const handleCancelSelection = () => {
    setSelectionMode(false);
    setSelectedMessages([]);
  };

  return (
    <View style={styles.container}>
      <ChatHeader
        selectionMode={selectionMode}
        handleCancelSelection={handleCancelSelection}
      />
      <Separator
        color={AppColors.grayColor_484848}
        marginHorizontal={15}
        height={2}
        marginTop={5}
        marginBottom={5}
        width="auto"
      />
      <View style={{ flex: 1 }}>
        {showLoader ? (
          <ShowLoader showIndicater={showLoader} />
        ) : chatData.length > 0 ? (
          <ChatList
            chatData={chatData}
            selectionMode={selectionMode}
            setSelectionMode={setSelectionMode}
            selectedMessages={selectedMessages}
            setSelectedMessages={setSelectedMessages}
          />
        ) : (
          <NoChatFound />
        )}
      </View>
      {!selectionMode && (
        <>
          <Separator
            color={AppColors.white}
            marginHorizontal={4}
            height={2}
            marginTop={15}
            marginBottom={10}
          />
          <ChatMessageInput
            newMessage={newMessage}
            setNewMessage={setNewMessage}
          />
        </>
      )}
    </View>
  );
};
const useStyles = CreateResponsiveStyle(
  {
    container: {
      backgroundColor: AppColors.gray_1F1F1F,
      borderRadius: 10,
      borderColor: AppColors.grayColor_282828,
      borderWidth: 1,
      padding: 20,
      marginTop: 15,
      flex: 1,
      margin: 15,
      paddingBottom: 10,
    },
    divider: {
      height: 1,
      backgroundColor: AppColors.grayColor_333333,
      marginTop: 10,
      marginBottom: 7,
    },
  },
  {
    [DEVICE_SIZES.XS]: {
      container: {
        flex: 1,
        alignSelf: "flex-end",
      },
    },
    [DEVICE_SIZES.SM]: {
      container: {
        flex: 1,
        alignSelf: "flex-end",
      },
    },
    [DEVICE_SIZES.MD]: {
      container: {
        flex: 1,
        alignSelf: "flex-end",
      },
    },
    [DEVICE_SIZES.LG]: {
      container: {
        flex: 1,
        alignSelf: "flex-end",
        width: "95%",
      },
    },
  }
);

export default withErrorBoundary(ChattingView);
